export default __webpack_public_path__ + "static/media/0088.2fb92617.jpg";